export default __webpack_public_path__ + "static/media/portada.e6f65309.jpg";